// Header logo lockup: icon + wordmark side by side.
//
// Stock Horizon's header-logo block renders either the theme's Logo image
// setting OR the store name as text, never both (blocks/_header-logo.liquid,
// `render 'image', image: settings.logo, ..., text_fallback: shop.name`).
// The mockup wants an icon next to a Playfair wordmark, so the Logo setting
// is set to the shield icon and this script appends the wordmark as a
// sibling inside the same <a class="header-logo"> link, reusing its
// existing href to the homepage rather than adding a second link.
(function () {
  function addWordmark(link) {
    if (link.querySelector('.gsb-logo-name')) return;

    var name = window.gsbLogoSettings && window.gsbLogoSettings.name;
    var showTagline = window.gsbLogoSettings && window.gsbLogoSettings.showTagline;
    var tagline = window.gsbLogoSettings && window.gsbLogoSettings.tagline;
    if (!name) return;

    var wordmark = document.createElement('span');
    wordmark.className = 'gsb-logo-name';
    wordmark.textContent = name;

    if (showTagline && tagline) {
      var small = document.createElement('small');
      small.textContent = tagline;
      wordmark.appendChild(small);
    }

    link.appendChild(wordmark);
  }

  function run() {
    document.querySelectorAll('a.header-logo').forEach(addWordmark);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
